import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b40c577"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-menu" }

import { IonHeader, IonContent } from "@ionic/vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'StaticMenu',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_menu = _resolveComponent("ion-menu")!

  return (_openBlock(), _createBlock(_component_ion_menu, { "content-id": "landing-page" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_img, {
                    src: "assets/icon/logo-complete.png",
                    class: "logo",
                    alt: "logo"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              to: "/about-us",
              class: "landing-menu__item"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" About us ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/contact-us",
              class: "landing-menu__item"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Contact us ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/terms-of-use",
              class: "landing-menu__item"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Terms of use ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/how-it-works",
              class: "landing-menu__item"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" How it works ")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})